import React from "react";
import '../../index.css'; // 假设CSS样式保存在这个文件中

const FineDiningExample = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">使用案例文案-正餐(适用于按桌号上菜的场景, 如西餐、火锅、烧烤等)</h1>

      <div className="section">
        <p className="store-info">Nali是一家位于墨西哥的火锅店, 拥有配菜间和炒菜间两个后厨, 服务流程为:</p>
        <ol>
          <li>1.	客人落座, 扫码点餐或者服务员帮忙下单.</li>
          <li>2.	火锅配菜和炒菜间后厨分别出票</li>
          <li>3.	后厨出餐后服务员上菜到桌位.</li>
          <li>4.	客人用餐完毕后前往前台或联系服务员结账.</li>
          <li>5.	清理桌位后, 准备接待下一位客人.</li>
        </ol>
        <p>此外客户还有以下需求:</p>
        <ol>
          <li>1.	会员注册需求, 针对老客户会提供充值1000赠送300的优惠活动.</li>
          <li>2.	税务需求, 需要系统可以自动计税, 并体现在小票上.</li>
          <li>3.	部分菜品只有周末早上供应, 希望超过时间自动下架.</li>
          <li>4.	餐厅有若干位合伙人, 合伙人希望可以看到餐厅的账目情况.</li>
          <li>5.	希望可以导出订单明细来作进一步数据分析.</li>
        </ol>
      </div>

      <div className="section">
        <h2>角色分工</h2>
        <ol>
          <li>1.店长用手机登录店长账号, 可以管理餐厅设置, 查看报表等, 但是不需要店长直接操作订单. {/*[后面跟一张截图]*/}</li>
          <img src="./meal/img_6.png" alt=""/>
          <li>2.员工在电脑上登录前台账号, 前台账号负责连接打印机以及操作订单, 比如下单, 加菜, 退菜, 结账、打印小票等. {/*[后面跟一张截图]*/}</li>
          <img src="./meal/img_7.png" alt=""/>
          <li>3.每个服务员用自己的手机登录自己专属的服务员账号, 服务员账号可以帮助客人下单, 可以加菜、结账, 也可以连接到一台打印机来打印小票. {/*[后面跟一张截图]*/}</li>
          {/* <img src="./meal/test3.png"  alt=""/> */}
          <li>4.合伙人用自己的手机登录合伙人账号, 合伙人账号可以看到餐厅的经营信息, 但是无法修改餐厅设置, 也无法操作订单. {/*[后面跟一张截图]*/}</li>
          {/* <img src="./meal/test4.png" style={{width:"400px"}} alt=""/> */}
        </ol>
      </div>

      <div className="section">
        <h2>打印机设置</h2>
        <p>前台部署一台收银打印机来打印收银小票给客人, 两个后厨分别部署两台打印机来分别打印凉菜和热菜的订单. 并且开启一菜一单, 出餐时小票跟随餐品交给服务员上菜.</p>
        {/*[放打印机设置截图, 和小票截图]*/}
        <img src="./meal/test5.png"  alt=""/>
      </div>

      <div className="section">
        <h2>会员设置</h2>
        <p>在会员设置中设置储值规则, 前台和服务员都可以帮助客人储值.</p>
        {/*[放设置截图]*/}
        <img src="./meal/img_8.png" alt=""/>
      </div>

      <div className="section">
        <h2>设置税务</h2>
        {/*[放税务设置截图, 结账页面截图, 小票图片]*/}

      </div>

      <div className="section">
        <h2>分时菜单</h2>
        <p>设置部分菜品只有周末早上供应.</p>
        {/*[设置页面截图]*/}
        <img src="./meal/test7.png" alt=""/>
      </div>

      <div className="section">
        <h2>导出订单</h2>
        <p>方便餐厅合伙人和店长对销售数据进行深入分析。</p>
        {/*[excel 截图]*/}
        <img src="./meal/test8.png" alt=""/>
      </div>

      {/* <div className="section">
        <h2>后厨显示系统(KDS)</h2>
        <p>后厨除了通过打印小票获取订单信息之外, 我们也支持使用后厨显示系统(KDS)来展示后厨订单, 厨师可以通过大屏幕来更直观的了解订单情况. <a href="link_to_kds_details">点击这里来查看详情</a>.</p> */}
        {/*[这里放一张后厨KDS的示意照片, 可以用西餐厅的示例]*/}
        {/* <img src="./meal/test9.png" alt=""/>
      </div> */}

      {/*[在此处可以根据实际内容继续添加其他必要的section]*/}

    </div>
  );
};

export default FineDiningExample;
